import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const SEO = (props) => {
  const { title, description, keywords, ogImage } = props;
  const location = useLocation();

  // Формируем канонический URL (гарантируя, что он заканчивается на "/")
  const canonicalUrl = `https://swaramusic.com${
    location.pathname.endsWith("/")
      ? location.pathname
      : location.pathname + "/"
  }`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};
